import type { ComponentProps } from 'react';
import { OwcTableGroup } from '@one/react';

export type PocTableGroupProps = ComponentProps<typeof OwcTableGroup>;

export const PocTableGroup: React.FC<PocTableGroupProps> = (props) => <OwcTableGroup {...props} />;
